import { Injectable } from '@angular/core';
import {MesApiService} from "./mes-api.service";

@Injectable({
  providedIn: 'root'
})
export class StoreHttpService extends MesApiService {

  constructor() {
    super(null);
  }
}
